import { render } from "./createClientComponent.vue?vue&type=template&id=2f55f188&scoped=true"
import script from "./createClientComponent.vue?vue&type=script&lang=js"
export * from "./createClientComponent.vue?vue&type=script&lang=js"

import "./createClientComponent.vue?vue&type=style&index=0&id=2f55f188&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f55f188"]])

export default __exports__